// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-a58ce19e],.v-card>h2[data-v-a58ce19e]{color:#1e88e5;font-weight:700}a[data-v-a58ce19e]{text-decoration:none}.right[data-v-a58ce19e]{float:right}.v-card p[data-v-a58ce19e]{text-align:center}.v-card .v-image[data-v-a58ce19e]{-webkit-transform:translate(-50%);transform:translate(-50%);left:50%;opacity:.6}.icon-image[data-v-a58ce19e]{opacity:.5;float:right}.white[data-v-a58ce19e]{-webkit-filter:invert(1);filter:invert(1);mix-blend-mode:lighten}", ""]);
// Exports
module.exports = exports;
